import React from 'react';

function TrashInCircleIcon({ fill = '#5D9CEC', width = 20, height = 20 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20">
            <path
                fill={fill}
                fillRule="nonzero"
                d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm1.25 2.75c.92 0 1.667.746 1.667 1.667l-.001.833h2.917a.417.417 0 1 1 0 .833h-1.25v7.167c0 1.105-.912 2-2.037 2H7.454c-1.125 0-2.037-.895-2.037-2l-.001-7.167h-1.25a.417.417 0 1 1 0-.833h2.917v-.833c0-.92.747-1.667 1.667-1.667h2.5zm2.5 3.333h-7.5v7.167c0 .64.536 1.167 1.204 1.167h5.092c.668 0 1.204-.526 1.204-1.167V7.083zm-5.833 1.25c.23 0 .416.187.416.417v5a.417.417 0 0 1-.833 0v-5c0-.23.187-.417.417-.417zm2.083 0c.23 0 .417.187.417.417v5a.417.417 0 0 1-.834 0v-5c0-.23.187-.417.417-.417zm2.083 0c.23 0 .417.187.417.417v5a.417.417 0 0 1-.833 0v-5c0-.23.186-.417.416-.417zm-.833-3.75h-2.5a.833.833 0 0 0-.833.834v.833h4.166v-.833a.833.833 0 0 0-.833-.834z"
            />
        </svg>
    );
}

export default TrashInCircleIcon;
